module.exports = __webpack_public_path__ + "img/11-fourImg.018ffca1.png";